import { render } from "./StudentProfile.vue?vue&type=template&id=6591a03a&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"

import "./StudentProfile.vue?vue&type=style&index=0&id=6591a03a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6591a03a"]])

export default __exports__